<template>
  <v-app>
    <v-container>
      <v-card>
        <v-card-title>
          Member Details
          <v-spacer></v-spacer>
          <edit-member-dialog class="ma-2" :member="member"></edit-member-dialog>
          <delete-member-dialog class="ma-2" :member="member"></delete-member-dialog>
          <v-btn text icon to="/members">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
      <v-card>
        <v-card-text>
          <h2 class="my-4">Member ID: {{ member.memberid }}</h2>
          <h2 class="my-4">Role: {{ member.role }}</h2>
          <h2 class="my-4">Name: {{ member.name }}</h2>
          <h2 class="my-4">Gender: {{ member.gender }}</h2>
          <h2 class="my-4">Work Location: {{ member.location }}</h2>
          <h2 class="my-4">Email Address: {{ member.email }}</h2>
          <h2 class="my-4">Contact Number: {{ member.contact }}</h2>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  props: ['id'],
  title: 'Member Details',
  computed: {
    member () {
      return this.$store.getters.loadedMember(this.id)
    }
  }
}
</script>

<style>

</style>
